import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowRightBlack, BehindDiscountCodeIcon, PreviousDiscountCodeIcon } from "../../../../assets/icons.constants";
import "./DiscountCodeButton.scss";

function DiscountCodeButton(props) {
  const { onClick, isBeingApplied = false, className } = props;
  const [t] = useTranslation();
  const pageData = {
    useDiscountMessage: t("checkOutPage.useDiscountMessage", "Sử dụng giảm giá"),
    discountHasBeenApplied: t("checkOutPage.discountHasBeenApplied", "Đã áp dụng giảm giá"),
  };
  function handleOnClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <div onClick={handleOnClick} className={`discount-code-button ${className}`}>
      <div className="icon-previous-discount-code">
        <PreviousDiscountCodeIcon />
      </div>
      <div className="text">{isBeingApplied ? pageData.discountHasBeenApplied : pageData.useDiscountMessage}</div>
      <div className="icon-arrow">
        <ArrowRightBlack className="icon-arrow-right" />
      </div>
      <div className="icon-behind-discount-code">
        <BehindDiscountCodeIcon />
      </div>
    </div>
  );
}

export default DiscountCodeButton;
